// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendors","assets"], () => (__webpack_require__("./node_modules/react-hot-loader/patch.js")))
let __webpack_exports__ = __webpack_require__.O(undefined, ["vendors","assets"], () => (__webpack_require__("./src/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
